import React, {useRef} from "react";
import { SystemPageType } from "../../../../Model/SystemModels";
import { ListHeaderEntry } from "../../../Common/Template/List/ListHeaderEntry";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";
import { ContainerType, PageDefinitionContainer } from "../../../Common/Template/PageDefinitionContainer";
import { AdminOpenAISetupCard } from "../AdminOpenAISetupCard/AdminOpenAISetupCard";

export const AdminOpenAISetupList : React.FC = () => {
    
    const cardRef = useRef<PageContainerBase>(null);
    
    return (
        <>
            <PageContainer endpoint={'/odata/openai/setup'} pageType={SystemPageType.List} title={"Setup OpenAI"} cardRef={cardRef} backAllowed insertAllowed updateAllowed>
                <PageDefinitionContainer type={ContainerType.Action}></PageDefinitionContainer>
                <PageDefinitionContainer type={ContainerType.PageStructure}>                    
                    <ListHeaderEntry fieldName="primaryKey" name="Chiave primaria" minWidth={100} maxWidth={200} />
                    <ListHeaderEntry fieldName="azureKeyCredential" name="Azure key credential" minWidth={100} maxWidth={200} />
                    <ListHeaderEntry fieldName="azureServiceEndpoint" name="Azure service endpoint" minWidth={100} maxWidth={200} />
                    <ListHeaderEntry fieldName="azureEmbeddingDeploymentName" name="Azure embedding deployment name" minWidth={100} maxWidth={200} />
                    <ListHeaderEntry fieldName="azureSearchDeploymentName" name="Azure search deployment name" minWidth={100} maxWidth={200} />
                    <ListHeaderEntry fieldName="scoreLimit" name="Score limit" minWidth={100} maxWidth={200} />
                </PageDefinitionContainer>
            </PageContainer>
            <AdminOpenAISetupCard ref={cardRef} />
        </>
    );
}